export default {
  SECTION_WIDGET_COUPON: {
    container: {
      cellWidth: {
        100: {
          allow: true,
          itemPerRow: 3,
        },
        66.67: {
          allow: true,
          itemPerRow: 3,
        },
        58.33: {
          allow: true,
          itemPerRow: 3,
        },
        50: {
          allow: true,
          itemPerRow: 2,
        },
        41.67: {
          allow: true,
          itemPerRow: 2,
        },
        33.33: {
          allow: true,
          itemPerRow: 1,
        },
        25: {
          allow: false,
          itemPerRow: 0,
        },
        20: {
          allow: false,
          itemPerRow: 0,
        },
        16.66: {
          allow: false,
          itemPerRow: 0,
        },
      },
    },
    fluid: {
      cellWidth: {
        100: {
          allow: true,
          itemPerRow: 4,
        },
        66.67: {
          allow: true,
          itemPerRow: 3,
        },
        58.33: {
          allow: true,
          itemPerRow: 3,
        },
        50: {
          allow: true,
          itemPerRow: 2,
        },
        41.67: {
          allow: true,
          itemPerRow: 2,
        },
        33.33: {
          allow: true,
          itemPerRow: 1,
        },
        25: {
          allow: false,
          itemPerRow: 0,
        },
        20: {
          allow: false,
          itemPerRow: 0,
        },
        16.66: {
          allow: false,
          itemPerRow: 0,
        },
      },
    },
  },
};
